export default "__VITE_ASSET__CnOVYsHV__"